export const PerformanceFeedbackConstants = {
    PERFORMANCE_FEEDBACK_CURRENT_PAGE: "PERFORMANCE_FEEDBACK_CURRENT_PAGE",
    PERFORMANCE_FEEDBACK_LIMIT_PER_PAGE: "PERFORMANCE_FEEDBACK_LIMIT_PER_PAGE",

    GET_PERFORMANCE_FEEDBACK_ERROR: "GET_PERFORMANCE_FEEDBACK_ERROR",
    GET_PERFORMANCE_FEEDBACK_SUCCESS: "GET_PERFORMANCE_FEEDBACK_SUCCESS",
    PERFORMANCE_FEEDBACK_LIMIT: "PERFORMANCE_FEEDBACK_LIMIT",
    PERFORMANCE_FEEDBACK_LOADING: "PERFORMANCE_FEEDBACK_LOADING",
};
